var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#509EE3",
  fillRule: "evenodd",
  d: "M12.524 6.216C12.1 4.096 10.234 2.5 8 2.5a4.623 4.623 0 0 0-4.524 3.716A3.703 3.703 0 0 0 0 9.92a3.701 3.701 0 0 0 3.692 3.71h8.616A3.701 3.701 0 0 0 16 9.92a3.703 3.703 0 0 0-3.476-3.704Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudFilled);
export default ForwardRef;